import { GiftIcon } from '@treams/treams-icons';
import { Container, Empty, Infinity, Skeleton } from '@treams/treams-ui';
import { QueryResult } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import IncomingComplimentCard from './IncomingComplimentCard';

export default function IncomingComplimentsList(props: {
	query: QueryResult<graphql.ViewerGivenComplimentsQuery>;
	userID: string;
}) {
	const { t } = useTranslation();

	const user = props.query.data?.user;

	return (
		<Container mb={3}>
			{user ? (
				user.viewerGivenCompliments.edges.length > 0 ? (
					<>
						{user.viewerGivenCompliments.edges
							.slice()
							.reverse()
							.map(({ node }) => (
								<IncomingComplimentCard
									key={node.id}
									userID={props.userID}
									compliment={node as graphql.Compliment}
								/>
							))}
						<Infinity query={props.query} path="user.viewerGivenCompliments" reverse>
							<Skeleton.Repeat count={10}>
								<IncomingComplimentCard.Skeleton />
							</Skeleton.Repeat>
						</Infinity>
					</>
				) : (
					<Skeleton.Empty
						contents={
							<Empty
								icon={<GiftIcon />}
								title={t('compliments.mutual.empty.title')}
								description={t('compliments.mutual.empty.description', {
									name: user.firstName,
								})}
							/>
						}
					>
						<Skeleton.Repeat count={3}>
							<IncomingComplimentCard.Skeleton />
						</Skeleton.Repeat>
					</Skeleton.Empty>
				)
			) : (
				<Skeleton.Repeat count={10}>
					<IncomingComplimentCard.Skeleton />
				</Skeleton.Repeat>
			)}
		</Container>
	);
}
